import AuditSystem from './AuditSystem';
import AuditEnterprise from './AuditEnterprise';
import AuditRobot from './AuditRobot';

export default {
  AuditSystem,
  AuditEnterprise,
  AuditRobot,
};



// WEBPACK FOOTER //
// ./src/manage-modules/AuditLog/index.js